import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import ListTable from '../../components/ListTable';
import SearchBar from '../../components/SearchBar';
import NewButton from '../../components/NewButton';
import DropdownActionButtons from '../../components/DropdownActionButtons';
import { actionsPermittedPropType } from '../../../services/GeneralTypes';

const Laboratories = (props) => {
  const {
    laboratories,
    query,
    routes,
    actionsPermitted,
  } = props;
  const urlNewLaboratory = routes.newLaboratoryPath;
  const urlLaboratory = routes.laboratoriesPath;

  const columns = [
    {
      header: 'Descrição',
      cell: ({ name }) => name,
    },
    {
      header: 'Ações',
      cell: (row) => (
        <DropdownActionButtons
          viewUrl={routes.laboratoryPath}
          editUrl={routes.editLaboratoryPath}
          deleteUrl={routes.laboratoryPath}
          itemId={row.id}
          actionsPermitted={actionsPermitted}
          deleteMessage={
            `Você tem certeza de que deseja excluir o laboratório <b>${row.name}</b>?
            <br>Esta ação é irreversível!`
          }
        />
      ),
      alignRight: true,
    },
  ];

  return (
    <>
      <Container className="rastreabilidade-container">
        <div>
          <Typography component="h1" variant="h2" align="center">
            Laboratórios
          </Typography>
          <SearchBar
            url={urlLaboratory}
            query={query}
          />
          <NewButton
            url={urlNewLaboratory}
            description="Novo Laboratório"
          />
          <ListTable
            columns={columns}
            data={laboratories}
          />
        </div>
      </Container>
    </>
  );
};

export const laboratoryPropType = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.string,
});

Laboratories.propTypes = {
  laboratories: PropTypes.arrayOf(laboratoryPropType).isRequired,
  query: PropTypes.string,
  routes: PropTypes.objectOf(PropTypes.string),
  actionsPermitted: actionsPermittedPropType,
};

export default Laboratories;
